export default "__VITE_ASSET__BE$37i6I__"